import React, { FC, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { CustomSpinner } from '@yakoffice/custom-spinner';
import { useGameVersions } from '../../../loaders/useGameVersions';
import { GameVersions } from './GameVersions';
import { usePageTitle } from '../pageTitleContext/PageTitleContext';
import { IGameVersion } from '../../../model/gameVersion/GameVersion';

export const GameVersionsContainer: FC = observer(() => {

    const [callbackTrigger, setCallbackTrigger] = useState<number>(0);

    const [activeGameVersion, setActiveGameVersion] = useState<number | null>();
    const [newGameVersion, setNewGameVersion] = useState<boolean>(false);

    const gameVersionsResult = useGameVersions(undefined, callbackTrigger);
    const { setPageTitle } = usePageTitle();

    setPageTitle(['Game Versions']);

    const updateCallbackTrigger = () => {
        setCallbackTrigger(callbackTrigger + 1);
    };

    const setTheActiveGameVersion = (gameVersion: IGameVersion | undefined) => {

        if (gameVersion === undefined)
            setActiveGameVersion(null);

        else setActiveGameVersion(gameVersion.id);
    };

    return gameVersionsResult.isLoaded && gameVersionsResult.gameVersions != null && gameVersionsResult.gameVersions.length > 0 ? (
        <GameVersions
            gameVersions={gameVersionsResult.gameVersions}
            updateCallbackTrigger={updateCallbackTrigger}
            activeGameVersion={gameVersionsResult.gameVersions.find(gameVersion => gameVersion.id === activeGameVersion)}
            setActiveGameVersion={setTheActiveGameVersion}
            newGameVersion={newGameVersion}
            setNewGameVersion={setNewGameVersion}
        />
    ) : (
        <CustomSpinner spinnerText={'Refreshing game versions...'} />
    );
});
